<template >
<div class="inner-wrapper">
    <div class="invoiceDetails table-responsive">
        <table class="table table-bordered table-hover">
            <thead>
                <tr>
                    <th>Shipment ID</th>
                    <th>Shipment Number</th>
                    <th>Order number</th>
                     <th></th>   
                   
                </tr>
            </thead>
            <tbody>
                <template
                    v-if="orderShipmentSearch !== null"
                >
                    <template v-for="(product, index) in orderShipmentSearch">
                        
                        
                        <tr>
                            <td>#{{ product.id }}</td>
                            <td>{{ product.tracking_no }}</td>
                            <td>{{ product.order ? product.order.order_number : ""}}</td>
                            <td>
                            <a class="btn create-btn" 
                                href="javascript:void(0);"
                                data-toggle="modal"
                                data-target="#addShippingModalOther"
                                
                                @click="otherCreateShipping(product)">Create Shipment</a>
                                                       
                            </td>

                            
                        </tr>
                        
                       

                    
                    </template>
                </template>
                <template v-else> </template>
            </tbody>
        </table>
        <AddShippingModalOther
            :orderShipmentSearch="orderShipmentData"
            :companyWarehouse="companyWarehouse"
            :customerWarehouse="customerWarehouse"
            :order="order.order"
            :po="order"
            :loading="loading"
            :shipping="shipping"
            :carriers="carriers"
            
        ></AddShippingModalOther>
    </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import axios from "axios";
import ShippingTrackingModal from "./ShippingTrackingModal";
import ShippingItemsModal from "./ShippingItemsModal";
import AddShippingModalOther from "./AddShippingModalOther";
export default {
    name: "OrderShipments",
    props: ["order", "po", "loading", "shippingProducts", "bus",'orderShipmentSearch','companyWarehouse',
            'customerWarehouse','order','po','shipping','carriers'
    ],
    components: { ShippingTrackingModal, ShippingItemsModal,AddShippingModalOther },
    mounted() {},
    data() {
        return {
            orderNew:{
                order:null
            },
            shifl_port_loading:null,
            shifl_port_discharge:null,
            shifl_port_terminal:null,
            indexshow:null,
            hideAndShow:null,
            shippingProductDetailId: null,
            shipmentDetails: [],
            shippingOrderItems: [],
            shippingByRefList: null,
            shippingByRef: null,
            shippingStatus: null,
            //shipping: null,
            orderShipmentData:{
                order:{
                    products:[]
                }
            },
        };
    },
    methods: {
        ...mapActions([
            "setCommonErrors",
            "setErrorMessage",
            "setSuccessMessage",
            "setLoading",
        ]),
        otherCreateShipping(shipping){
            console.log(shipping);
            console.log(shipping.order);
            this.orderShipmentData = shipping;
            console.log("this.orderShipmentData set ",this.orderShipmentData);
            //this.getOrder();
            //$('#addShippingModalOther').modal('show');
        },

        

        showtrInfo(index,mbl_number,shipId){
            // console.log("index",index);
            // return "";
             if(this.hideAndShow == index){
                this.indexshow = null;
                this.hideAndShow = null;
                console.log("here ");
                console.log("indexshow ",this.indexshow);
                console.log("indexshow ",this.hideAndShow);
                //this.hideAndShow = true;
            }
            else{
                console.log("Thhere ");
                this.indexshow = index;
                this.hideAndShow = index;
                console.log("indexshow ",this.indexshow);
                console.log("indexshow ",this.hideAndShow);
            }
            //this.indexshow = index
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .post(
                    window.route("po.getShppingNumberByMbl", {
                        id: shipId,
                    }),
                    { mbl_number: mbl_number },
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        console.log("data shfl shipping number : ", data);
                        
                        this.shifl_port_loading = data.shipment_detail ? data.shipment_detail.location_from : "";
                        this.shifl_port_discharge = data.shipment_detail ? data.shipment_detail.port_of_discharge : "";
                        this.shifl_port_discharge = data.data ? data.data.terminal : "";
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                        //this.getOrder();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });

        },

        

        getShipmentTracking(carrierCompany, shipmentNo) {
            console.log(" carrierCompany ", carrierCompany);
            console.log(" shipmentNo ", shipmentNo);

            if (carrierCompany == "Maersk Line") {
                window.open(
                    "https://www.maersk.com/tracking/" + shipmentNo,
                    "_blank"
                );
            } else if (carrierCompany == "Orient Overseas Container Line Ltd.") {
                window.open(
                    "https://www.oocl.com/eng/Pages/default.aspx" + shipmentNo,
                    "_blank"
                );
            } else if (carrierCompany == "American President Lines") {
                window.open(
                    "https://www.apl.com/ebusiness/tracking/search" +
                        shipmentNo,
                    "_blank"
                );
            } else if (carrierCompany == "Ocean Network Express (ONE Line)") {
                window.open(
                    "https://ecomm.one-line.com/one-ecom/manage-shipment/cargo-tracking?trakNoParam=" +
                        shipmentNo,
                    "_blank"
                );
            } else if (carrierCompany == "ZIM Integrated Shipping Services Ltd") {
                window.open(
                    "https://www.zim.com/tools/track-a-shipment?consnumber=" +
                        shipmentNo,
                    "_blank"
                );
            } else if (carrierCompany == "COSCO Container Lines") {
                window.open(
                    "https://elines.coscoshipping.com/ebusiness/cargoTracking?trackingType=BILLOFLADING&number=" +
                        shipmentNo,
                    "_blank"
                );
            } else if (carrierCompany == "Hapag Lloyd Container Line/A") {
                window.open(
                    "https://www.hapag-lloyd.com/en/online-business/track/track-by-booking.html?blno=" +
                        shipmentNo,
                    "_blank"
                );
            } else if (carrierCompany == "Evergreen Line") {
                window.open(
                    "https://connect.track-trace.com/for/superbpackaging/billoflading/" +
                        shipmentNo,
                    "_blank"
                );
            } else if (carrierCompany == "Turkon Line Inc") {
                window.open(
                    "https://my.turkon.com/container-tracking" + shipmentNo,
                    "_blank"
                );
            } else if (carrierCompany == "Transfer") {
                window.open(
                    "https://www.transfarshipping.com/tracking?blNo=" +
                        shipmentNo,
                    "_blank"
                );
            } else if (carrierCompany == "MSC") {
                window.open(
                    "https://www.msc.com/en/track-a-shipment",
                    "_blank"
                );
            } else if (carrierCompany == "Wan Hai Lines") {
                window.open(
                    "https://www.wanhai.com/views/Main.xhtml",
                    "_blank"
                );
            } else if (carrierCompany == "TS Lines") {
                window.open(
                    "https://vgm.tslines.com/CargoTracking/CargoTrackingBL",
                    "_blank"
                );
            } else if (carrierCompany == "SM Line") {
                window.open(
                    "https://esvc.smlines.com/smline/CUP_HOM_3301.do",
                    "_blank"
                );
            } else if (carrierCompany == "Yang Ming Line") {
                window.open(
                    "https://www.yangming.com/e-service/Track_Trace/track_trace_cargo_tracking.aspx?str=" +
                        shipmentNo +
                        "&rdolType=BL",
                    "_blank"
                );
            } else if (carrierCompany == "Hyundai Merchant Marine Co., Ltd.") {
                window.open(
                    "https://www.hmm21.com/e-service/general/DashBoard.do",
                    "_blank"
                );
            } else if (carrierCompany == "Hamburg Sud") {
                window.open(
                    "https://www.hmm21.com/e-service/general/DashBoard.do",
                    "_blank"
                );
            } else if (carrierCompany == "Compagnie Maritime d Affretement Compagnie Generale Maritime") {
                window.open(
                    "https://www.cma-cgm.com/ebusiness/tracking",
                    "_blank"
                );
            } else if (carrierCompany == "UPS") {
                window.open(
                    "https://www.ups.com/track?loc=en_US&requester=ST/",
                    "_blank"
                );
            } else if (carrierCompany == "Fedex") {
                window.open(
                    "https://www.fedex.com/fedextrack/no-results-found?trknbr=" +
                        shipmentNo,
                    "_blank"
                );
            } else if (carrierCompany == "DHL") {
                window.open(
                    "https://www.dhl.com/us-en/home/tracking/tracking-express.html?submit=1&tracking-id=" +
                        shipmentNo,
                    "_blank"
                );
            } else if (carrierCompany == "Other") {
            } else {
            }
        },
        getShippingDetails(mblNumber) {
            console.log("mblNumber mblNumbe r", mblNumber);
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .post(
                    window.route("po.getShppingNumberByMbl", {
                        id: this.order.id,
                    }),
                    { mbl_number: mblNumber },
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        console.log("data shiipng number : ", data);
                        this.shipmentDetails = data.data.data;
                        this.showShimpment = true;
                        this.shipmentId = data.data.data.shipment_id;
                        console.log("this.shipmentId : ", this.shipmentId);
                        this.shippingOrderItems = data.orders;
                        $("#shippingTrackingModal1").modal("show");
                        console.log(
                            "this.shippingOrderItems ",
                            this.shippingOrderItems
                        );
                        // this.setSuccessMessage(
                        //     "Label added to this order successfully!"
                        // );
                        //this.isEditLabelSection = false;
                        //this.newLabelId = [];
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                        //this.getOrder();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },

        toggleShippingProductDetailId(product) {
            if (this.shippingProductDetailId === product.id) {
                this.shippingProductDetailId = null;
            } else {
                this.shippingProductDetailId = product.id;
            //     let self = this;
            // this.setLoading(true);
            // this.setCommonErrors([]);
            // this.setErrorMessage(null);
            // return axios
            //     .post(
            //         window.route("po.getShppingNumberByMbl", {
            //             id: product.id,
            //         }),
            //         { mbl_number: product.mbl_number },
            //         {
            //             validateStatus: function (status) {
            //                 return status < 500; // Resolve only if the status code is less than 500
            //             },
            //         }
            //     )
            //     .then(({ data }) => {
            //         if (data.errorMessage) {
            //             self.setErrorMessage(data.errorMessage);
            //             if (data.errors) {
            //                 self.setCommonErrors(data.errors);
            //             }
            //         } else {
            //             console.log("data shfl shipping number : ", data);
                        
            //             this.shifl_port_loading = data.shipment_detail ? data.shipment_detail.location_from : "";
            //             this.shifl_port_discharge = data.shipment_detail ? data.shipment_detail.port_of_discharge : "";
            //             this.shifl_port_discharge = data.data ? data.data.terminal : "";
            //             setTimeout(() => {
            //                 self.setSuccessMessage(null);
            //             }, 5000);
            //             //this.getOrder();
            //         }
            //     })
            //     .catch((error) => {
            //         self.setErrorMessage(
            //             error.response && error.response.errorMessage
            //                 ? error.response.errorMessage
            //                 : error.message
            //         );
            //     })
            //     .finally(() => {
            //         self.setLoading(false);
            //     });
            }
            this.$emit(
                "toggleShippingProductDetailIdEvent",
                this.shippingProductDetailId
            );
        },
        getShippingQuantityByStatus(product, status) {
            let total = 0;
            if (status) {
                product.shippings
                    .filter((x) => x.status === status)
                    .forEach((x) => {
                        total += x.pivot.quantity;
                    });
            } else {
                product.shippings.forEach((x) => {
                    total += x.pivot.quantity;
                });
            }

            return total;
        },
        getShipmentStatusById(id) {
            let self = this;
            this.shippingStatus = null;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            return axios
                .get(
                    window.route("so.getShipmentStatusById", {
                        id: this.order.id,
                        shipment_id: id,
                    }),
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        //console.log(data.data);
                        this.shippingStatus = data.data.data;

                        $("#shippingTrackingModal").modal("show");
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        getShipmentByRef(shipping, id) {
            this.shipping = _.cloneDeep(shipping);
            let self = this;
            this.shippingStatus = null;
            this.shippingByRefList = null;
            this.shippingByRef = null;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            return axios
                .get(
                    window.route("so.getShipmentByRef", {
                        id: this.order.id,
                        tracking_no: id,
                        type: "BYCONTAINER",
                    }),
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        //console.log(data.data);
                        if (data.data.success) {
                            this.shippingByRefList = _.cloneDeep(
                                data.data.data
                            );
                            let shippings =
                                data.data.data.BYCONTAINER.Active.filter(
                                    (x) => x["MBL#"] == id
                                );
                            if (shippings.length) {
                                this.shippingByRef = _.cloneDeep(shippings[0]);
                                //console.log(shippings[0]['Shifl Ref#'])
                                //console.log(shippings[0]['Shifl Ref#'].substr(1, shippings[0]['Shifl Ref#'].length))
                                //let ship_id = shippings[0]['Shifl Ref#'].substr(1, shippings[0]['Shifl Ref#'].length);
                                //this.getShipmentStatusById(ship_id);
                            } else {
                                shippings =
                                    data.data.data.BYCONTAINER.Completed.filter(
                                        (x) => x["MBL#"] == id
                                    );
                                if (shippings.length) {
                                    this.shippingByRef = _.cloneDeep(
                                        shippings[0]
                                    );
                                    //let ship_id = shippings[0]['Shifl Ref#'].substr(1, shippings[0]['Shifl Ref#'].length);
                                    //this.getShipmentStatusById(ship_id);
                                }
                            }
                        }
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);

                    if (this.shippingByRef) {
                        let ship_id = this.shippingByRef["Shifl Ref#"].substr(
                            1,
                            this.shippingByRef["Shifl Ref#"].length
                        );
                        this.getShipmentStatusById(ship_id);
                    }
                });
        },
    },
    computed: {},
    watch: {},
};
</script>

<style scoped></style>
